// Long
export const page = {
    layout: 'portrait', //p=portrait, l=landscape
    layoutL: 'landscape', //p=portrait, l=landscape
    papersize: {
        format: 'legal',
        // height: 330.2, //330.2mm or 13inches // 355.6 14
        // width: 215.9, //215.9mm or 8.5inches
        height: 1000, //long
        width: 600,  //long
        unit: 'mm'
    },
    spacingunit: 4, //in mm
    headerFromTop: 5, //in mm
    footerFromBottom: 10, //in mm
    margin: {
        top: 15, //in mm
        bottom: 0, //in mm
        left: 20, //in mm
        right: 20 //in mm
    },
    maxWidthInPoint: 215.9 - 20 - 20 //in ??? don't know
}

// Short
export const pageShort = {
    layout: 'portrait', //p=portrait, l=landscape
    layoutL: 'landscape', //p=portrait, l=landscape
    papersize: {
        format: 'letter',
        height: 800,
        width: 600,
        unit: 'mm'
    },
    spacingunit: 5, //in mm
    headerFromTop: 5, //in mm
    footerFromBottom: 10, //in mm
    margin: {
        top: 15, //in mm
        bottom: 0, //in mm
        left: 10, //in mm
        right: 10 //in mm
    },
    maxWidthInPoint: 215.9 - 20 - 20 //in ??? don't know
}